/* eslint-disable */
import React, { PureComponent } from 'react'

export default class BaseComponent extends PureComponent {
  constructor(props) {
    super(props)
  }

  _bind(...methods) {
    methods.forEach( (method) => this[method] = this[method].bind(this) )
  }
}



// WEBPACK FOOTER //
// ./src/utils/BasePureComponent.js